export default __webpack_public_path__ + "static/media/expense.a8c9a044.png";